import { useState } from "react";
import ErrorBoundary from "../components/ErrorBoundary";

import { Box } from "@mui/material";
import LandingFooter from "../components/LandingFooter";
import KwikScoutLogo from "../components/onboarding/KwikScoutLogo";
import ProgressBar from "../components/onboarding/ProgressBar";
import Step1AdminData from "../components/onboarding/Step1AdminData";
import Step2ValidateToken from "../components/onboarding/Step2ValidateToken";
import Step3TermsAndConditions from "../components/onboarding/Step3TermsAndConditions";
import Step5Success from "../components/onboarding/Step5Success";
import LoginScreen from "../components/onboarding/LoginScreen";

const stepLabels = [
  "Dados do acesso",
  "Validação do código de segurança",
  "Nossos termos e condições de uso",
];

const LandingTestContent = ({initialStep}) => {
  const [step, setStep] = useState(initialStep || 1);
  const [data, setData] = useState({
    session_id: null,
    expiration_timeout: 0,
    retry_timeout: 0,
    requested_at_ms: 0,
    adminData: {}
  })
  const [loginPrefillPhone, setLoginPrefillPhone] = useState("");

  return (
    <div className="bg-background flex flex-col">
      <div className="w-full max-w-2xl mx-auto px-4 pt-10 pb-6">
        <KwikScoutLogo />
        {step <= 3 && (
          <ProgressBar step={step} totalSteps={3} label={stepLabels[step - 1]} />
        )}
      </div>

      <div className="flex-1 flex items-start justify-center px-4 pb-10">
        {step === 1 && <ErrorBoundary componentName="Step1AdminData" showReload logToBackend title="Erro no cadastro" message="Ocorreu um erro ao processar seus dados de cadastro. Tente novamente."><Step1AdminData setSession={(session_data) => setData(session_data)} onNext={() => setStep(2)} onLogin={(phone)=> { setLoginPrefillPhone(phone || ""); setStep(6); }}/></ErrorBoundary>}
        {step === 2 && <ErrorBoundary componentName="Step2ValidateToken" showReload logToBackend title="Erro na valida\u00e7\u00e3o" message="Ocorreu um erro ao validar o c\u00f3digo de seguran\u00e7a. Tente novamente."><Step2ValidateToken data={data} onNext={() => setStep(3)} onBack={() => setStep(1)} /></ErrorBoundary>}
        {step === 3 && <ErrorBoundary componentName="Step3TermsAndConditions" showReload logToBackend title="Erro nos termos" message="Ocorreu um erro ao carregar os termos e condi\u00e7\u00f5es. Tente novamente."><Step3TermsAndConditions data={data} onNext={() => setStep(4)} /></ErrorBoundary>}
        {step === 4 && <ErrorBoundary componentName="Step5Success" showReload logToBackend title="Erro na finaliza\u00e7\u00e3o" message="Ocorreu um erro inesperado. Tente novamente."><Step5Success /></ErrorBoundary>}
        {step === 6 && <ErrorBoundary componentName="LoginScreen" showReload logToBackend title="Erro no login" message="Ocorreu um erro ao processar o login. Tente novamente."><LoginScreen setSession={(session_data) => setData(session_data)} onNext={() => setStep(7)} goBack={()=>setStep(1)} initialPhone={loginPrefillPhone} /></ErrorBoundary>}
        {step === 7 && <ErrorBoundary componentName="Step2ValidateToken-Login" showReload logToBackend title="Erro na valida\u00e7\u00e3o" message="Ocorreu um erro ao validar o c\u00f3digo de login. Tente novamente."><Step2ValidateToken data={data} onNext={() => setStep(4)} onBack={() => setStep(6)} login /></ErrorBoundary>}
      </div>
    </div>
  );
};

const LandingTestNow = ({step}) => {
  const initialStep = step || 1

	return (
		<ErrorBoundary
			componentName="LandingTestNow"
			fullScreen
			showReload
			logToBackend
			title="Erro no cadastro"
			message="Ocorreu um erro inesperado durante o processo de cadastro ou login. Tente novamente."
		>
		<Box className="landing">
      <LandingTestContent initialStep={initialStep} />
			<LandingFooter />
		</Box>
		</ErrorBoundary>
	)
}


export default LandingTestNow;
